import Vue from 'vue'
// import createPersistedState from 'vuex-persistedstate'
import Vuex from 'vuex'
// import VueCookie from 'vue-cookie';
// import Cookies from 'js-cookie';

import modules from './modules'
Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  plugins: [
    // createPersistedState({
    //   paths: ['PosShiftLog'],
    //   storage: {
    //     getItem: key => Cookies.get(key),
    //     setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: true }),
    //     removeItem: key => Cookies.remove(key)
    //   }
    // })
  ],
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js